<template>
  <div id="about">
    <el-container>
      <div style="margin-top:40px;">
        <div style="margin:40px 100px;">          
          <div style="padding:40px;background-color:#ffffff;margin-bottom:20px;">
            <div class="title" style="margin-bottom:40px;">— 公司介绍 —</div>  
            <el-row :gutter="40">                            
              <el-col :span="24">                              
                <div style="font-size:14px;line-height:28px;text-align:justify;text-indent:2em">北京睿哲志远管理咨询有限公司（原名：北京智联博才信息咨询有限公司）,在过去几十年间，人员评价和发展技术在全球范围内得到了巨大的发展。我们与欧洲心理协会、美国工业心理协会保持长期的合作与研发资源的共享，自2008年开创以来，服务与广大的500强企业及大中型内外资企业，结合我们全球资源及国内外专家团队，为企业广泛地提供招募与选拔、胜任力模型构建应用、流程优化、职业生涯规划、培训与发展、组织行为诊断等各方面的解决方案。</div>
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;text-indent:2em">在现今快速发展而有竞争激烈的全球经济背景下，整合的人员管理是企业的首要任务，它能为企业的战略决策提供真正的洞见。经过多年的积累，我们已服务超过10000家企业，累计上百万人的测评数据及样本报告，涉及金融、能源、汽车、通信、制造、地产、航空、零售等50多个行业。</div>
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;text-indent:2em">我们的服务宗旨是将企业战略转化为现实。帮助企业在日常工作中运用先进的管理方法和专业的操作手段，更有效的发掘提高个人和组织的潜质，提升绩效，实现企业高效运营和快速成长。这意味着我们并未仅仅对相关人员、技能和岗位提供帮助，而从深层次中挖掘将经营战略与个人发展那种紧密相连的关系。</div>
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;text-indent:2em">睿哲咨询始终坚持高质量的研究和理性严谨的态度，高质量的数据和对科学的妥善运用始终居于我们所有解决方案的核心，这是睿哲咨询做出的根本性承诺，这是我们的工作动力。</div>
              </el-col>
            </el-row>
            <div style="margin-top:40px">
              <el-row :gutter="60">
                <el-col :span="8">
                  <div class="sub-title">我们的价值理念</div>
                  <div><span style="color:red;font-weight:bold;">"专业主义"</span> 提供超越期望的优质服务</div>
                  <div style="margin-top:20px; line-height:2"><span style="color:red;font-weight:bold;">"专注主义"</span>在人力资源选、用、育、留整个过程中深耕细作</div>
                </el-col>
                <el-col :span="8">
                  <div class="sub-title">我们的态度</div>
                  <div style="line-height:2">始终坚持高质量的研究和理性严谨的态度，高质量的数据和对科学的妥善运用始终居于我们所有解决方案的核心</div>
                </el-col>
                <el-col :span="8">
                  <div class="sub-title">我们的服务</div>
                  <div>
                    <span class="item-option">模型构建</span>
                    <span class="item-option">岗位分析</span>
                    <span class="item-option">评价中心</span>
                    <span class="item-option">能力测评</span>
                    <span class="item-option">360度调研</span>
                    <span class="item-option">压力与组织氛围调研</span>
                    <span class="item-option">员工满意度</span>
                    <span class="item-option">培训发展</span>
                    <span class="item-option">领导力转变</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            
          </div>
          <div style="padding:40px;background-color:#ffffff;margin-bottom:20px;" >
            <el-row>
              <el-col :span="24">
                <div  class="title">— 我们的客户 —</div>
                <div class="block" style="text-align:center;">
                  <el-row>
                    <el-col :span="12">
                      <img src="../assets/images/jinrong.gif" alt="" srcset="" style="width:100%" >
                    </el-col>
                    <el-col :span="12">
                      <img src="../assets/images/dichan.gif" alt="" srcset=""  style="width:100%">
                    </el-col>                    
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
export default {
  name:'about',
  mounted(){
    
  }
}
</script>
<style scoped>
#about {
  background-color: #f4f4f4;
}
.main-container {
  margin: 0 100px;
}
.title{
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #333;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: center;
  padding: 0 0 20px 0;
}
.about{
  width: 100%;
}
.sub-title{
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #05A4C2;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: left;
  padding: 0 0 20px 0;
}
.item-option{
  padding: 6px 10px;
  margin-right:10px;
  word-wrap: break-word;
  display: inline-block;
  border: 1px solid #eeeeee;
  font-size: 14px;
  color: #828282;
  margin-bottom: 8px;  
}
</style>
